module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/point_photowedding_01@2x-418e9921a8c3c16f292c2fd4230e1191.webp";